/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from 'react';

import { Container, Row, Col } from 'reactstrap';

function AdminFooter() {
  return (
    <>
      <Container fluid>
        <footer className="footer pt-0">
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="6">
              <div className="copyright text-xl-left text-muted">
                ©{' '}
                <a
                  className="font-weight-bold ml-1 text-purple"
                  href={process.env.REACT_APP_HOMEPAGE}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {process.env.REACT_APP_COPYRIGHT}
                </a>{' '}
                <span className="font-weight-normarl text-default">
                  all rights reserved
                </span>
              </div>
            </Col>
          </Row>
        </footer>
      </Container>
    </>
  );
}

export default AdminFooter;
